import React, {memo, useEffect, useState} from "react";
import {Pie} from "react-chartjs-2";
import {getRevenueStageStatistics} from "../../../api/admin";
import {getData} from "./colors";

const RevenueStage = (submissionType) => {
  const [revenueStage, setRevenueStage] = useState([]);
  useEffect(() => {
    getRevenueStageStatistics(submissionType).then((data) => {
      setRevenueStage(data);
    });
  }, [submissionType]);

  const revenueStageData = (revenueStage && revenueStage.data) || [];
  const labels = revenueStageData.map((c) => c._id) || [];
  const data = revenueStageData.map((c) => c.count) || [];

  return <Pie data={getData({labels, data})} type="pie" />;
};

export default memo(RevenueStage);
